import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";

/**
 * Firebase client setup.
 *
 * The config values are public by design — they identify the project, they do not
 * authorise anything. Authorisation is the ID token, which the API verifies and
 * then re-checks against Postgres membership on every request.
 */
const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "demo-onecpa-local",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "onecpa-local",
  authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "onecpa-local"}.firebaseapp.com`,
});

export const auth = getAuth(app);

// Pointing at the emulator is a local-only branch, and it must run before any
// auth call. In production the variable is absent and this is skipped entirely.
const emulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;
if (emulatorHost) {
  connectAuthEmulator(auth, `http://${emulatorHost}`, { disableWarnings: true });
}
